import { format } from 'date-fns';
import { TableColumn } from '../components/ui/Table';
import {
  SubscriberDownladed,
  Subscribers,
  SubscriberTable,
} from '../models/subscriber';

const SubscriberColumn: TableColumn<SubscriberTable>[] = [
  { id: 'id', label: 'ID' },
  { id: 'email', label: 'Email' },
  { id: 'name', label: 'Name' },
  { id: 'createdAt', label: 'Subscribed At' },
];

export const SubscriberToSubscriberTable = (subscribers: Subscribers[]) => {
  const data: any = subscribers.map(
    ({ id, email, name, city, type, createdAt }, index) => ({
      id: id,
      serial: (index + 1).toString(),
      type: type ?? 'N/A',
      email: email,
      name: name ?? 'N/A',
      city: city ?? 'N/A',
      createdAt: format(new Date(createdAt), 'MM-dd-yyy hh:mm a'),
      actions: 'ACTIONS',
    }),
  );
  return { headers: SubscriberColumn, data };
};

export const SubscriberDownloadedData = (subscribers: any) => {
  // const data: SubscriberDownladed[] = subscribers.map(
  //   ({ email, type, createdAt }, index) => ({
  //     serial: (index + 1).toString(),
  //     email: email,
  //     type: type ?? 'N/A',
  //     subscribedAt: format(new Date(createdAt), 'MM-dd-yyy hh:mm a'),
  //   }),
  // );
  return { data: subscribers };
};
